import { getContactosByNifAndEmpresaId } from "api/Contacto.service"
import { getFacturaById } from "api/Factura.service"
import { useSelector } from "hooks/useSelector"
import { useUsuarioByCurrent } from "hooks/useUsuarioByCurrent"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { globalSelector } from "routes/globalSlice"
import { rectificarOeditarMapObj } from "../../features/Documentos/pages/Facturas/FacturasEnviadas/constants/rectificarOeditarMapObj"

export const useRectificarFactura = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { usuarioByCurrent } = useUsuarioByCurrent()
  const empresaActiva = usuarioByCurrent?.empresaActiva
  const { formasPago, tiposImpuestosGenerales } = useSelector(globalSelector)

  const rectificarOeditarFactura = async (
    docAsociado?: string | null,
    id?: string,
    esBorrador?: boolean
  ) => {
    try {
      if (!id) {
        // eslint-disable-next-line no-console
        console.error("Error al recibir id de la factura.")
        return
      }

      const facturaArectificarOeditarBorrador = await getFacturaById(id)

      const librado = await getContactosByNifAndEmpresaId(
        facturaArectificarOeditarBorrador?.cliente?.cif,
        empresaActiva?.id
      )

      const facturaArectificarOeditarBorradorObj = rectificarOeditarMapObj({
        t,
        id,
        documento: facturaArectificarOeditarBorrador,
        librado,
        librador: empresaActiva,
        formasPago,
        tiposImpuestosGenerales,
        docAsociado,
        esBorrador,
      })

      history.push(ROUTES.CREAR_FACTURA, facturaArectificarOeditarBorradorObj)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  return { rectificarOeditarFactura }
}
